import React, { useMemo } from "react";
import {Link} from "@chakra-ui/react";

function DownloadLink({ filename, content, mimeType = "text/plain" }) {
    // Generate the object URL once per content change
    const href = useMemo(() => {
        const blob = new Blob([content], { type: mimeType });
        return URL.createObjectURL(blob);
    }, [content, mimeType]);

    return (
        <Link
            href={href}
            download={filename}
            fontSize={'xs'}
            variant={'underline'}>
            Download {filename}
        </Link>

        // <a
        //     href={href}
        //     download={filename}
        //     className="chakra-link"
        // >
        //     Download {filename}
        // </a>
    );
}

export default DownloadLink;